import React from "react";
import style from "./Edu_Validation.module.css";
import Sidebar from "../../Sidebar/Sidebar";
import signPer from "../../../Assets/Signup/signPer.svg";
import { Link } from "react-router-dom";

const Edu_Validation = () => {
  return (
    <>
      <div className="flex">
        <Sidebar />
        <div>
          <p className={`${style.header} px-12 pt-8`}>Professor Raghu</p>
          <div className="ml-12 mt-11">
            <div className={`${style.container} grid grid-cols-2`}>
              <div
                className={`${style.Profile} flex flex-col gap-6 justify-center items-center`}
              >
                <div>
                  <img
                    src={signPer}
                    alt="signPer"
                    className={`${style.ProImage}`}
                  />
                </div>

                <div className={`${style.ProBtn}`}>
                  <button>Identification Proof</button>
                </div>
                <div className={`${style.ProBtnSec}`}>
                  <button>VALIDATE</button>
                </div>
              </div>

              <div className={`${style.ProfileContent}`}>
                <p>
                  Name: Raghunath Vishvanath Iyer Qualification: MTech ECE Phone
                  Number: 1234567890 DOB: 19-09-1999 Email Id: basgwad@gmail.com
                  Experience: 12 years
                </p>
              </div>
            </div>
            <div className={`${style.btnFinal} m-4`}>
              <button>
                <Link to="/Admin_Dashboard">Dashboard</Link>
              </button>
            </div>
          </div>
        </div>

        <div>
          <div className={`${style.search}`}></div>
        </div>
      </div>
    </>
  );
};

export default Edu_Validation;
